const SnackbarActionTypes = {
	OPEN_SNACKBAR : "OPEN_SNACKBAR",
	CLOSE_SNACKBAR : "CLOSE_SNACKBAR",
};

export default SnackbarActionTypes;
